import React from 'react';
import PropTypes from 'prop-types';
import ButtonSpinner from '../../components/ButtonSpinner';
import RichSelectField from '../../components/formfields/RichSelectField';

const PreviousCardSelector = ({
  isVisible,
  loading,
  loaded,
  cards,
  selectedCardId,
  onSelectCard
}) => {
  // Don't render if not visible
  if (!isVisible) {
    return null;
  }

  // Loading state
  if (loading) {
    return <ButtonSpinner loading={loading} />;
  }

  // Empty state
  if (loaded && cards?.length === 0) {
    return (
      <p className="text-sm text-gray-500">
        No previous cards found. Please add a new card.
      </p>
    );
  }

  // Cards available
  if (cards?.length > 0) {
    return (
      <div className="mb-5">
        <RichSelectField
          id="previous-cards"
          label="Select Previous Card"
          value={selectedCardId}
          valueKey="id"
          onChange={(e) => {
            const value = e.target.value;
            const selectedCard = cards.find(card => card.id === value);
            onSelectCard?.(selectedCard);
          }}
          onBlur={(e) => {
            const value = e.target.value;
            const selectedCard = cards.find(card => card.id === value);
            onSelectCard?.(selectedCard);
          }}
          options={cards}
          formatValue={(option) => ({
            key: option?.id,
            icon: null,
            label: `${option?.display_name} ${option?.expiration_date}`,
            value: option?.id
          })}
          placeholder="Previous Card Not Selected"
          required
        />
      </div>
    );
  }

  // Default: nothing to show
  return null;
};

PreviousCardSelector.propTypes = {
  /**
   * Whether this component should be visible (typically tied to active tab)
   */
  isVisible: PropTypes.bool.isRequired,

  /**
   * Whether cards are currently being loaded
   */
  loading: PropTypes.bool.isRequired,

  /**
   * Whether cards have been loaded (used to determine empty state)
   */
  loaded: PropTypes.bool.isRequired,

  /**
   * Array of previous card objects
   */
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      display_name: PropTypes.string.isRequired,
      expiration_date: PropTypes.string.isRequired,
    })
  ),

  /**
   * ID of the currently selected card
   */
  selectedCardId: PropTypes.string,

  /**
   * Callback function when a card is selected
   * @param {Object} card - The selected card object
   */
  onSelectCard: PropTypes.func.isRequired,
};

PreviousCardSelector.defaultProps = {
  cards: [],
  selectedCardId: '',
};

export default PreviousCardSelector;